import { render, staticRenderFns } from "./submitBtn.vue?vue&type=template&id=4084a4e6&scoped=true&"
import script from "./submitBtn.vue?vue&type=script&lang=js&"
export * from "./submitBtn.vue?vue&type=script&lang=js&"
import style0 from "./submitBtn.vue?vue&type=style&index=0&id=4084a4e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084a4e6",
  null
  
)

export default component.exports